import React from "react";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import "./headboardRouter.scss";




const HeadboardRouter: React.FC<ReferenciaCabecera> = React.memo((props) => {
    const nombreRuta = localStorage.getItem('routeName');
    const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

    return (
        <div className="o-headboardRouter__container">
            <h1 className="o-headboardRouter__title">
                <span>
                    {nombreRuta && capitalize(nombreRuta)}, {props.tituloSpan}
                </span>
            </h1>
            {props.imagenHeader?.file?.url && (
                <div className="o-headboardRouter__banner">
                    <div className="o-headboardRouter__icon">
                        <img
                            src={props.imagenHeader.file.url}
                            alt={props.imagenHeader.description || "ImagenEnrutador"}
                        />
                    </div>
                    <span className="o-headboardRouter__banner-text">{props.tituloPrincipal}</span>
                </div>
            )}
        </div>
    );
});

export default HeadboardRouter;
